import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {buildItemPickersUrl} from '@github-ui/item-picker-base/api/urls'
import {CreateMilestone} from '@github-ui/server-persisted-queries'
import type {CreateMilestoneMutation} from '@github-ui/server-persisted-queries/types/CreateMilestone'

export type CreateMilestoneRequest = {
  repositoryId: string
  title: string
}

export type CreateMilestoneResponse = GraphQLResponse<CreateMilestoneMutation>

export async function apiCreateMilestone(request: CreateMilestoneRequest): Promise<CreateMilestoneResponse> {
  const pathname = buildItemPickersUrl('milestones')

  const init = {
    method: 'POST',
    body: {...request, queryId: CreateMilestone},
  }

  const response = await verifiedFetchJSON(pathname, init)
  return response.json() as Promise<CreateMilestoneResponse>
}
